module.exports = __webpack_public_path__ + "static/flags/MT-ab5d542bd2b7424443ce7f74b87b5dc8.gif";